export default {
  "article.title": "Czym jest arkusz USFans? Kompletny poradnik dla początkujących",
  "article.meta_description": "Dowiedz się, czym jest arkusz USFans, dlaczego kupujący go używają, jak go zorganizować i co sprawdzić przed zakupem. Poradnik przyjazny dla początkujących z praktycznymi wskazówkami.",
  "article.breadcrumb_home": "Strona główna",
  "article.breadcrumb_current": "Poradnik arkusza USFans",
  "article.updated": "Ostatnia aktualizacja",
  "article.read_time": "6 min czytania",
  "article.toc": "Spis treści",
  "article.toc_1": "Czym jest arkusz USFans?",
  "article.toc_2": "Dlaczego warto używać arkusza podczas zakupów?",
  "article.toc_3": "Jak zorganizować arkusz USFans",
  "article.toc_4": "Typowe kolumny do uwzględnienia",
  "article.toc_5": "Wskazówki dla początkujących",
  "article.toc_6": "Często zadawane pytania",

  "article.intro": "Arkusz USFans to uporządkowane źródło, którego wielu kupujących używa do organizowania, porównywania i śledzenia produktów podczas przeglądania. Ten poradnik wyjaśnia, czym jest arkusz USFans, dlaczego może być pomocny, jak skutecznie go skonfigurować i o czym pamiętać przed dokonaniem zakupu.",

  "article.h2_1": "Czym jest arkusz USFans?",
  "article.p_1a": "Mówiąc prościej, arkusz USFans to tabela używana do zbierania informacji o produktach w jednym miejscu. Zamiast przewijać długi katalog i próbować zapamiętać to, co widziałeś, możesz zapisywać interesujące Cię produkty — ich kategorię, referencję, rozmiar, cenę i wszelkie notatki dotyczące jakości lub wysyłki.",
  "article.p_1b": "Arkusz nie jest oficjalnym narzędziem. To praktyczny sposób na uporządkowanie badań zakupowych. Wiele osób tworzy własną wersję, dodając tylko te kolumny, które mają dla nich znaczenie.",

  "article.h2_2": "Dlaczego warto używać arkusza podczas zakupów?",
  "article.p_2a": "Arkusz pomaga na kilka praktycznych sposobów. Po pierwsze, trzyma wszystkie Twoje opcje widoczne naraz, dzięki czemu możesz porównywać produkty obok siebie bez otwierania wielu kart. Po drugie, zmniejsza ryzyko zapomnienia o produkcie, który Ci się spodobał. Po trzecie, daje Ci jasny zapis tego, co rozważasz, co jest przydatne, jeśli planujesz kupować przez kilka dni.",
  "article.p_2b": "Jest szczególnie pomocny, gdy porównujesz podobne produkty z różnych kategorii — na przykład sprawdzając, czym kurtka różni się od bluzy pod względem dostępnych rozmiarów, referencji i notatek.",

  "article.h2_3": "Jak zorganizować arkusz USFans",
  "article.p_3a": "Nie potrzebujesz specjalnego oprogramowania. Prosty arkusz w dowolnej aplikacji do arkuszy działa dobrze. Zacznij od wiersza nagłówkowego, który nazywa każdą kolumnę, a następnie dodaj jeden wiersz na każdy rozważany produkt.",
  "article.p_3b": "Zachowaj prosty układ. Celem jest przejrzystość, nie złożoność. Zawsze możesz później dodać lub usunąć kolumny, gdy zmienią się Twoje potrzeby.",

  "article.h2_4": "Typowe kolumny do uwzględnienia",
  "article.table_header": "Praktyczny układ na początek",
  "article.table_col1": "Kolumna",
  "article.table_col2": "Do czego służy",
  "article.row1_col1": "Produkt",
  "article.row1_col2": "Nazwa lub opis produktu",
  "article.row2_col1": "Kategoria",
  "article.row2_col2": "Buty, bluzy, kurtki i tak dalej",
  "article.row3_col1": "Referencja",
  "article.row3_col2": "Kod lub SKU identyfikujący produkt",
  "article.row4_col1": "QC",
  "article.row4_col2": "Notatki dotyczące kontroli jakości",
  "article.row5_col1": "Wysyłka",
  "article.row5_col2": "Metoda wysyłki lub notatki o dostawie",
  "article.row6_col1": "Status",
  "article.row6_col2": "Rozważany, zamówiony lub odebrany",

  "article.h2_5": "Wskazówki dla początkujących",
  "article.tip_1": "Zacznij od krótkiej listy i dodawaj kolumny tylko wtedy, gdy ich potrzebujesz.",
  "article.tip_2": "Używaj spójnej referencji lub SKU, aby móc ponownie znaleźć ten sam produkt.",
  "article.tip_3": "Zapisuj datę i źródło wszelkich informacji, które notujesz.",
  "article.tip_4": "Zapisuj cenę i szczegóły wysyłki jako notatkę, a następnie zweryfikuj je na głównej stronie przed zakupem.",

  "article.faq_title": "Często zadawane pytania",
  "article.faq_q1": "Czy potrzebuję specjalnej aplikacji, aby utworzyć arkusz USFans?",
  "article.faq_a1": "Nie. Wystarczy dowolny arkusz lub nawet prosta notatka. Ważna jest przejrzysta, spójna struktura.",
  "article.faq_q2": "Czy arkusz jest oficjalnym produktem USFans?",
  "article.faq_a2": "Nie. To ogólna metoda organizacji używana przez kupujących, a nie oficjalne narzędzie żadnego sprzedawcy.",
  "article.faq_q3": "Czym to się różni od zwykłego przeglądania katalogu?",
  "article.faq_a3": "Przeglądanie pokazuje produkty jeden po drugim. Arkusz pozwala trzymać listę wybranych produktów razem i porównywać je bezpośrednio.",

  "article.cta_title": "Gotowy, aby to wykorzystać w praktyce?",
  "article.cta_body": "Teraz, gdy rozumiesz, jak działa arkusz USFans, przejdź na główną stronę, aby przeglądać produkty i zacząć budować własną listę.",
  "article.cta_button": "Przeglądaj produkty na głównej stronie",
  "article.back_home": "Powrót do strony głównej",
  "article.related_title": "Powiązane zasoby",
  "article.related_1": "Opinia o USFans",
  "article.related_2": "Poradnik kosztów wysyłki USFans",
  "article.related_3": "Czy USFans jest legalny?",
};